<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">日常辅助</Breadcrumb-item>
        <Breadcrumb-item>操作日志</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="操作日期:">
              <DatePicker @on-change="atimeDateChange" format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                          placement="bottom-start" placeholder="" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="操作人">
              <Input placeholder="ID/昵称" name="adminKey"
                     v-model="queryParam.adminKey"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="入口">
              <Input placeholder="访问入口" name="action"
                     v-model="queryParam.action"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="路径">
              <Input placeholder="接口地址" name="uri"
                     v-model="queryParam.uri"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="ip">
              <Input placeholder="ip地址" name="ip"
                     v-model="queryParam.ip"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="请求参数">
              <Input placeholder="模糊搜素" name="params"
                     v-model="queryParam.params"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="平台">
              <Select v-model="queryParam.sysFrom" placeholder="请选择" clearable>
                <Option value="1">管理后台</Option>
                <Option value="2">学生中心</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/activity/log/query"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>

export default {
  components: {},
  data () {
    let $constant = this.$constant
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        startTime: '',
        endTime: '',
        sysFrom: '',
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      title: [
        {
          title: '操作人',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.adminId === 0) {
              return h('div', '')
            }
            return h('div', [
              h('span', row.adminId),
              h('span', ' - '),
              h('span', row.adminName)
            ])
          }
        },
        {
          title: '平台',
          align: 'center',
          render: (h, params) => {
            let sysFrom = params.row.sysFrom
            if (sysFrom === 1) {
              return h('span', '管理后台')
            }
            return h('span', '学生中心')
          }
        },
        {
          title: '入口',
          align: 'center',
          key: 'action'
        },
        {
          title: '路径',
          align: 'center',
          key: 'uri'
        },
        {
          title: '参数',
          align: 'center',
          render: (h, params) => {
            let p = params.row.params || ''  // 防止params为null或undefined
            let displayText = p.length > 50 ? p.substring(0, 50) + '...' : p
            // 显示前5个句子
            // 如果超过5个句子，使用Poptip显示全部
            if (displayText.length > 50) {
              return h('Poptip', {
                props: {
                  placement: 'top',
                  transfer: true,
                  wordWrap: true,
                  maxWidth: 300
                }
              }, [
                h('div', {
                  style: {
                    'white-space': 'pre-line',
                    'cursor': 'pointer'
                  }
                }, `${displayText}\n...`),
                h('div', {
                  slot: 'content',
                  style: {
                    'white-space': 'pre-line',
                    'max-height': '200px',
                    'overflow-y': 'auto'
                  }
                }, p)
              ])
            }
            // 不超过5个句子，直接显示
            return h('div', {
              style: {
                'white-space': 'pre-line'
              }
            }, displayText)
          }
        },
        {
          title: '时间',
          align: 'center',
          width: 180,
          key: 'createTime'
        },
        {
          title: 'IP',
          align: 'center',
          key: 'ip'
        }
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    atimeDateChange (value) {
      this.queryParam.startTime = value[0]
      this.queryParam.endTime = value[1]
      this.search()
    },
  }
}

</script>

<style lang="less" scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// LogList.vue?b4aff006